import React from 'react'

const ContentCardHover = () => {
  return <></>
}

export default ContentCardHover
